/* eslint eqeqeq: 0*/
import React, { Component } from 'react';
import { connect } from 'react-redux';
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import {Field, reduxForm} from 'redux-form';
import CloseIcon from '../CloseIcon';
import { BODY_TEXT_COLOR, THIRD_COLOR, NEGATIVE_COLOR, ERROR_COLOR } from '../../config/colors';
import * as modal from '../../reducers/modalReducer';

import { rootPageUri } from '../../config/uri';
import styled from 'styled-components';
import './style.css';
import { enableScroll } from '../../helpers/scroll';
import { startActivateUser } from '../../actions/signup-sync';

import { hasUpperCase, hasLowerCase, hasNumbers } from '../../helpers/validators';
import { pushWithQueryParams } from '../../services/uri';
import { RESET_PASSWORD_SUCCESS } from '../../const/password_const';
import { RESULT_CODE } from '../../const/result_code_const';
import { resetPassword } from '../../actions/signup-async';
const $ = require("jquery");

/* validators begin */
const required = value => value ? undefined : 'Required'
const maxLength = max => value =>
  value && value.length > max ? `Must be ${max} characters or less` : undefined
const maxLength15 = maxLength(15)
const minLength = min => value =>
  value && value.length < min ? `Must be ${min} characters or more` : undefined
const minLength7 = minLength(7);

// const number = value => value && isNaN(Number(value)) ? 'Must be a number' : undefined
// const minValue = min => value =>
//   value && value < min ? `Must be at least ${min}` : undefined
// const minValue6 = minValue(6)
// const email = value =>
//   value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value) ?
//   'Invalid email address' : undefined
/* validators end */

const CONTAINER_HEIGHT = '100%';
const styles = {
    closeIconWrap: {"position":"absolute","right":"10px", top: '10px' },
    floatingText: {color: NEGATIVE_COLOR },
    textField: {width: '100%', fontSize: '16px', fontWeight:'400', color: BODY_TEXT_COLOR },
    underlineStyle: {borderColor: BODY_TEXT_COLOR },
    closeIcon: {height:'35px', width:'35px', color: THIRD_COLOR },
    labelStyle: {fontWeight:700},
    errorText: {color: ERROR_COLOR}
}

const validate = values => {
  const errors = {}
  if (values.password !== values.password2) {
    errors.password2 = 'Passwords Do Not Match'
  }
  return errors
}
class PasswordForm extends Component {
 
    passwordField = null;
    fields = {
        'password1': null,
        'password2': null
    }

    secondaryColor = ['#',this.props.secondaryColor].join('');
    floatingLabelStyle = { color: this.secondaryColor };
    floatingFocusLabelStyle = { color: this.secondaryColor };
    underlineFocusStyle = { borderColor: this.secondaryColor };

    state = {
        isOpen: true,
        isInputAddressActive: false,
        inputNameFocused: null,
        mainContainerHeight: CONTAINER_HEIGHT,
        resetPasswordError: '',
    }


    handleInputEnterPress = (e,  inputName, touched, error) => {
        if ((e.key === 'Enter' || e.key == '13') && error === undefined) {
            if (inputName === 'password') {
                e.preventDefault();
                this.onInputBlur('password');
                setTimeout(()=>{
                    this.passwordField2.focus();
                },250);
            }
        }
    }

    onInputFocus = (inputName) => {
        const { isPhone, is_iPhone } = this.props;
        if (is_iPhone) return;
        if (isPhone) {
            const height = [$('.greetigs').height()/2,'px']; 
            this.setState({
                isInputAddressActive: true,
                inputNameFocused: inputName,
                mainContainerHeight: height.join('')
            })
        }
    }

    onInputBlur = (inputName) => {
        const { isPhone, is_iPhone } = this.props;
        if (is_iPhone) return;
        if (isPhone) {
            this.setState({
                isInputAddressActive: false,
                inputNameFocused: null,
                mainContainerHeight: CONTAINER_HEIGHT
            })  
        }    
    }

   renderPasswordField = ({input, label, meta: {touched, error}, ...custom}) => (
        <TextField
            ref={input => this.passwordField = input}
            type="password"
            onKeyPress={(e) => this.handleInputEnterPress(e, 'password', touched, error)}
            onFocus={()=>this.onInputFocus('password')}
            onBlur={()=>this.onInputBlur('password')}
            floatingLabelText={<span style={styles.floatingText}>Enter password</span>}
            style={styles.textField}
            floatingLabelStyle={this.floatingLabelStyle}
            floatingLabelFocusStyle={this.floatingLabelFocusStyle}
            underlineStyle={styles.underlineStyle}
            underlineFocusStyle={this.underlineFocusStyle}
            errorText={(touched && error ? error : '')}
            {...input}
            {...custom}
        />
    )

   renderPasswordField2 = ({input, label, meta: {touched, error}, ...custom}) => (
        <TextField
            ref={input => this.passwordField2 = input}
            type="password"
            onKeyPress={(e) => this.handleInputEnterPress(e, 'password2', touched, error)}
            onFocus={()=>this.onInputFocus('password2')}
            onBlur={()=>this.onInputBlur('password2')}
            floatingLabelText={<span style={styles.floatingText}>Re-enter password</span>}
            style={styles.textField}
            floatingLabelStyle={this.floatingLabelStyle}
            floatingLabelFocusStyle={this.floatingLabelFocusStyle}
            underlineStyle={styles.underlineStyle}
            underlineFocusStyle={this.underlineFocusStyle}
            errorText={(touched && error ? error : '')}
            {...input}
            {...custom}
        />
    )

  handleSubmit = (e) => {
      if (e) e.preventDefault();
      enableScroll();
      this.setState({resetPasswordError: ''});
      const password = this.props.password.PasswordForm.values.password;
      if (this.props.type === 'PASSWORD_RESET') {
        const data = { retrieveToken: this.props.retrieveToken, password };

        resetPassword(data).then(
          response => {
            const {
              resultCode,
            } = response.data;
    
    
            if (resultCode === RESULT_CODE.FAIL) {
              this.setState({
                resetPasswordError: 'Invalid token to reset password',
              });
              return;
            }
    
            this.props.hideModal();
            this.props.openResetPasswordSuccessMessage();
            this.props.openMainPage();
          }, error => {
            this.setState({
              resetPasswordError: 'Invalid token to reset password',
            });
          }
        );
      } else {
        this.props.activateUser(password, this.props.signup);
      }
  }

  handleExit = () => {
    this.props.hideModal();
    enableScroll();
    this.props.openMainPage();
  }

  render() {
    const { pristine, error, valid} = this.props;
    const { resetPasswordError } = this.state;

    return (
        <form name="Password" onSubmit={this.handleSubmit} style={{margin: '20px 0'}}>
          <div onClick={this.handleExit} style={styles.closeIconWrap}><CloseIcon style={styles.closeIcon} /></div>
          <FormWrapperDiv style={{height: this.state.mainContainerHeight}}>
            <HeaderDiv>Password</HeaderDiv>
              <div className="password-hint">Please enter your desired password</div>
              <div className="login-input">
                <Field 
                  name="password" 
                  validate={[ required, minLength7, maxLength15, hasLowerCase, hasUpperCase, hasNumbers ]}
                  component={this.renderPasswordField} />
              </div>
              <div className="login-input">
                <Field 
                  name="password2" 
                  validate={[ required, minLength7, maxLength15, hasLowerCase, hasUpperCase, hasNumbers ]}
                  component={this.renderPasswordField2} />
              </div>
              {!this.state.isInputAddressActive &&
                <div style={{marginTop:'10px'}}>
                  <RaisedButton
                    disabled={pristine || !valid}
                    type="submit"
                    backgroundColor={`#` + this.props.secondaryColor}
                    labelColor="#FFF"
                    labelStyle={styles.labelStyle}
                    label="Next"
                  />
                </div>
              }
              {resetPasswordError && <div>
                <label style={styles.errorText}>{resetPasswordError}</label>
              </div>
              }
              {error}
            </FormWrapperDiv>
        </form>
    );
  }
}

PasswordForm = reduxForm({
  destroyOnUnmount: true,
  forceUnregisterOnUnmount: true,
  form: 'PasswordForm',
  validate
})(PasswordForm);

const mapStateToProps = (state) => {
  return {
    primaryColor: state.config.primaryColor,
    secondaryColor: state.config.secondaryColor,
    user: state.user,
    password: state.form,
    signup: state.signup,
    type: state.modal.modalProps.type,
    retrieveToken: state.modal.modalProps.retrieveToken,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    activateUser: (password, signupData) => dispatch(startActivateUser(password, signupData)),
    openMainPage: () => dispatch(pushWithQueryParams(rootPageUri)),
    hideModal: () => dispatch(modal.hideModal()),
    openResetPasswordSuccessMessage: () => dispatch(modal.openModal({
      modalType: 'MESSAGE_MODAL',
      modalProps: { message: RESET_PASSWORD_SUCCESS }
    }))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PasswordForm);

const HeaderDiv = styled.div `
  font-size: 39px;
  line-height: 39px;
  font-weight: 700;
  font-family: 'Futura-Bold';
  text-align: center;
  max-width: 275px;
    @media (max-width: 320px) {
        font-size: 35px;
        line-height: 35px;
    }
`;

const FormWrapperDiv = styled.div `
    display: flex;
    color: ${BODY_TEXT_COLOR};
    flex-direction: column;
    font-size: 18px;
    align-items: center;
    justify-content: center;
    margin: 20px auto 20px;
    height: 100%;
    font-family: 'Futura-Bold', 'Futura-Bold';
`;


// WEBPACK FOOTER //
// ./src/components/PasswordForm/PasswordForm.jsx